export default "__VITE_ASSET__LnxSoW_a__"